const B_1 = [
    {
        title: '发票管理',
        path: '/manage/finance/invoice/list',
    }
]

export default {
    path: 'invoice',
    component: () => import(/*webpackChunkName: 'finance-invoice'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'finance-invoice'*/ '@views/manage/views/finance/invoice/list'),
            meta: {
                title: '发票管理',
                topNav: true,
                bread: B_1
            },
        }, 
        {
            path:"form",
            component: () => import(/*webpackChunkName: 'finance-invoice'*/ '@views/manage/views/finance/invoice/form'),
            meta: {
                title: '编辑发票',
                bread: [
                    ...B_1,
                    {
                        title: '编辑发票',
                        path: '/manage/finance/invoice/form', 
                    }
                ]
            },
        }, 

        {
            path:"elec/list",
            component: () => import(/*webpackChunkName: 'finance-invoice'*/ '@views/manage/views/finance/invoice/sub-pages/list-elec-invoice'),
            meta: {
                title: '发票管理',
                bread: [
                    ...B_1,
                    {
                        title: '电子发票使用情况',
                        path: '/manage/finance/invoice/elec/list', 
                    }
                ]
            },
        }, 
        {
            path:"elec/detail",
            component: () => import(/*webpackChunkName: 'finance-invoice'*/ '@views/manage/views/finance/invoice/sub-pages/detail-elec-invoice'),
            meta: {
                title: '编辑发票',
                bread: [
                    ...B_1,
                    {
                        title: '电子发票使用情况',
                        path: '/manage/finance/invoice/elec/list', 
                    },
                    {
                        title: '电子发票使用情况详情',
                        path: '/manage/finance/invoice/elec/detail', 
                    }
                ]
            },
        }, 
    ]
}
